import { create } from 'zustand';
import type { Selection } from './types';

interface AppState {
  role: string; userId: string; selected: Selection | null; drawerOpen: boolean; sidebarOpen: boolean;
  activeLayers: string[]; commandOpen: boolean; lowBandwidth: boolean;
  forecastHour: number; forecastHorizon: number; forecastPlaying: boolean; forecastSpeed: number;
  setRole: (role: string, userId?: string) => void; select: (selected: Selection | null) => void;
  toggleLayer: (id: string) => void; toggleSidebar: () => void; setCommandOpen: (open: boolean) => void;
  setLowBandwidth: (enabled: boolean) => void;
  setForecastHour: (hour: number) => void; setForecastHorizon: (hour: number) => void;
  setForecastPlaying: (playing: boolean) => void; setForecastSpeed: (speed: number) => void;
}

const storedRole = typeof localStorage === 'undefined' ? null : localStorage.getItem('karhutla-role');
export const useAppStore = create<AppState>((set) => ({
  role: storedRole ?? 'national-watch-officer', userId: 'usr-001', selected: null, drawerOpen: false, sidebarOpen: true,
  activeLayers: ['risk-grid', 'verified-perimeter', 'forecast-perimeters', 'smoke-plume', 'resources', 'drone-tracks'], commandOpen: false, lowBandwidth: false,
  forecastHour: 6, forecastHorizon: 12, forecastPlaying: false, forecastSpeed: 1,
  setRole: (role, userId) => { localStorage.setItem('karhutla-role', role); set({ role, userId: userId ?? `demo-${role}`, selected: null, drawerOpen: false }); },
  select: (selected) => set({ selected, drawerOpen: Boolean(selected) }),
  toggleLayer: (id) => set((state) => ({ activeLayers: state.activeLayers.includes(id) ? state.activeLayers.filter((item) => item !== id) : [...state.activeLayers, id] })),
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  setCommandOpen: (commandOpen) => set({ commandOpen }),
  setLowBandwidth: (lowBandwidth) => set({ lowBandwidth }),
  setForecastHour: (forecastHour) => set((state) => ({ forecastHour: Math.max(0, Math.min(state.forecastHorizon, forecastHour)) })),
  setForecastHorizon: (forecastHorizon) => set((state) => ({ forecastHorizon, forecastHour: Math.min(state.forecastHour, forecastHorizon) })),
  setForecastPlaying: (forecastPlaying) => set({ forecastPlaying }),
  setForecastSpeed: (forecastSpeed) => set({ forecastSpeed })
}));
